import { makeAutoObservable } from "mobx";
import { IdMap } from "../../collections";
import { ActivationState } from "./ActivationState";
export class WholeOrderPromotionInstance {
    constructor(params) {
        this.kind = "WholeOrder";
        this.id = params.id;
        this.promotionType = params.promotionType;
        this._activationState = params.activationState;
        this._freebie = params.freebie;
        this.excludedInstances = IdMap.empty();
        makeAutoObservable(this);
    }
    static fromStorageData(params) {
        const { promotionType, id, storageData } = params;
        if (promotionType.scope.kind !== "WholeOrder") {
            return null;
        }
        return new WholeOrderPromotionInstance({
            id,
            promotionType,
            activationState: ActivationState.fromStorageData(storageData.active),
            freebie: params.freebie,
        });
    }
    setExcludedInstances(excluded) {
        this.excludedInstances = excluded;
    }
    get active() {
        return ActivationState.isActive(this._activationState);
    }
    get activationState() {
        return this._activationState;
    }
    setActive(active) {
        this._activationState = active
            ? ActivationState.UserEnabled
            : ActivationState.UserDisabled;
        if (active) {
            this.excludedInstances.objects.forEach((excludedInstance) => excludedInstance.setActive(false));
        }
    }
    setActivationState(state) {
        this._activationState = state;
    }
    get freebie() {
        return this._freebie;
    }
    setFreebie(freebie) {
        this._freebie = freebie;
    }
    get storageData() {
        return {
            kind: "WholeOrderPromotionInstance",
            promotionTypeId: this.promotionType.id.value,
            active: ActivationState.storageData(this._activationState),
            freebie: this.freebie === null ? null : this.freebie.storageData,
        };
    }
}
